import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import Button from '../common/button/button';
import Form from './previsaoPesoForm';

import { setModoTela, initForm, salvar, excluir, getLista } from './previsaoPesoActions';

class PrevisaoPeso extends Component {

    componentWillMount() {
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <ContentHeader title='Previsão de Peso' small='Cadastro' />
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<BoxButtonHeader>
					<Button
						text='Adicionar'
						type={'success'}
						icon={'fa fa-plus'}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm();
						}} />
				</BoxButtonHeader>
				<Table>
					<THead>
						<Tr>
							<Th>Familia</Th>
							<Th>Sexo</Th>
							<Th>Raça</Th>
							<Th>Idade</Th>
							<Th alignRight>Peso</Th>
							<Th alignCenter acoes>Ações</Th>
						</Tr>
					</THead>
					<TBody>
						{(this.props.lista).map(item => (
							<Tr key={item.id}>
								<Td>{item.nome_familia || 'Não informada'}</Td>
								<Td>{item.nome_sexo || 'Não informado'}</Td>
								<Td>{item.nome_raca || 'Não informada'}</Td>
								<Td>{item.idade_inicio} até {item.idade_fim} meses</Td>
								<Td alignRight>{String(item.peso).replace('.', ',')}</Td>
								<Td alignCenter>
									<ButtonTable
										type={'warning'}
										icon={'fa fa-pencil'}
										event={() => {
											this.props.setModoTela('cadastro', { ...item, peso: item.peso.replace('.', ',') });
											this.props.initForm({ ...item, peso: item.peso.replace('.', ',') });
										}} />
									<ButtonTable
										type={'danger'}
										icon={'fa fa-trash-o'}
										event={() => {
											this.props.setModoTela('exclusao', { ...item, peso: item.peso.replace('.', ',') });
											this.props.initForm({ ...item, peso: item.peso.replace('.', ',') });
										}} />
								</Td>
							</Tr>
						))}
					</TBody>
				</Table>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	modoTela: state.previsaoPeso.modoTela,
	lista: state.previsaoPeso.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PrevisaoPeso);
